import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";

import lazyComponent from "./lazy";

export default {
    component: lazyComponent,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({ title: allMessage["homework"], allMessage, lang });
    },
} satisfies IRoute;
